import React from 'react'
import { MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function AboutUsHero() {
  return (
    <MotionSection className="w-full py-12 lg:py-16">
      <div className="grid gap-10 lg:grid-cols-2 items-center">
        <MotionDiv className="w-[96%] mx-auto lg:mx-0 lg:ml-[2%] pl-0 sm:pl-3 md:pl-5 lg:pl-[30px] space-y-4" delay={0.02}>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">Our Story</h1>
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-xl">
            Logo Branded Door Mats Johannesburg was founded to solve a specific problem: the lack of high-quality,
            durable branded matting available on short notice in South Africa. For years, South African businesses
            had to choose between cheap, locally printed mats that faded within months or expensive overseas imports
            that took nearly a quarter of a year to arrive. We decided to bridge that gap. Based in the heart of
            Gauteng's industrial hub — Isando, Kempton Park — we combine global matting technologies such as HD
            Nylon and WaterHog with local craftsmanship and rapid-response logistics, delivering the best of both
            worlds with our industry-leading 2–3 day turnaround.
          </p>
        </MotionDiv>

        <MotionImage className="w-full lg:pl-6" delay={0.08}>
          <div className="w-full h-64 sm:h-80 lg:h-[440px] overflow-hidden bg-gray-100 lg:-mt-6 rounded-2xl lg:rounded-3xl shadow-lg">
            <img
              src="/images/sectionimages/abouthero.png"
              alt="Logo Branded Door Mats Johannesburg facility"
              className="w-full h-full object-cover rounded-2xl lg:rounded-3xl"
            />
          </div>
        </MotionImage>
      </div>
    </MotionSection>
  )
}
